import { useEffect } from 'react';
import L from 'leaflet';
import { useMap } from 'react-leaflet';
import 'leaflet.markercluster/dist/leaflet.markercluster';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';

import { MASTERIMAGES } from '../../../../../commons/api';

const markerClusters = L.markerClusterGroup();

const MarkerCluster = ({ markers, parentCallback }) => {
  const map = useMap();

  useEffect(() => {
    markerClusters.clearLayers();

    markers &&
      Array.isArray(markers) &&
      markers.forEach((mark) => {
        const { position, status, title, asset } = mark;

        const popupContent = `<h2>${title}</h2>`;
        let imageFile = '';

        // Determine image based on asset type
        switch (asset) {
          case 'RS':
            imageFile = MASTERIMAGES.RS_PNG;
            break;
          case 'ITV':
            imageFile = MASTERIMAGES.ITV_PNG;
            break;
          case 'ECH':
            imageFile = MASTERIMAGES.ECH_PNG;
            break;
          case 'GIS Tracking':
            imageFile = MASTERIMAGES.GISTRACKING_PNG;
            break;
          case 'MHC':
          case 'MHCS1':
            imageFile = MASTERIMAGES.ST_MHC_V1_PNG;
            break;
          case 'QC':
          case 'QCS1':
          case 'QCS2':
            imageFile = MASTERIMAGES.ST_QC_V1_PNG;
            break;
          case 'RTG':
          case 'RTGS1':
          case 'RTGS2':
            imageFile = MASTERIMAGES.ST_RTG_V1_PNG;
            break;
          default:
            imageFile = MASTERIMAGES.DEFAULT_PNG;
        }

        // Determine status color
        let color = 'white';
        if (status === 'Running') {
          color = '#27A82A';
        } else if (status === 'StandBy') {
          color = '#858282';
        } else if (status === 'Idle') {
          color = '#E3E30B';
        }

        // Create marker with custom HTML icon
        const marker = L.marker([position.lat, position.lng], {
          icon: new L.DivIcon({
            className: 'my-div-icon',
            html: `
              <div>
                <img height="60" width="60" class="my-div-image" src="${imageFile}" />
                <span style="color: black; font-weight: bold; margin-left: 25px;">
                  <span class="circle-css" style="background-color:${color}; border-radius: 50%; display:inline-block; width:10px; height:10px; margin-right:5px;"></span>
                  ${title}
                </span>
              </div>
            `
          })
        });

        marker.bindTooltip(popupContent);
        marker.on('click', () => parentCallback(mark));
        markerClusters.addLayer(marker);
      });

    map.addLayer(markerClusters);
  }, [markers, map, parentCallback]);

  return null;
};

export default MarkerCluster;
